<template>
  <section class="shortcut-datetime">
    <el-date-picker
      :clearable="clearable"
      v-model="date"
      type="daterange"
      range-separator="至"
      start-placeholder="开始时间"
      end-placeholder="结束时间"
      :picker-options="pickerOptions"
      @change="onDateChange"
      :unlink-panels="true"
      :time-arrow-control="true"
    ></el-date-picker>
  </section>
</template>
<script>
import dayjs from "dayjs";
export default {
  props: {
    currentDate: Array,
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      date: [],
      pickerOptions: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: "去年",
            onClick(picker) {
              const currentYear = dayjs().year();
              const start = dayjs(`${currentYear - 1}-01-01`);
              const end = dayjs(`${currentYear - 1}-12-31`).endOf("day");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              const lastMonthDate = dayjs().subtract(1, "month");
              const start = lastMonthDate.startOf("month");
              const end = lastMonthDate.endOf("month");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const lastWeekDate = dayjs().subtract(1, "week");
              const start = lastWeekDate.startOf("week").add(1, "day");
              const end = lastWeekDate
                .endOf("week")
                .add(1, "day")
                .subtract(1, "millisecond");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const yesterday = dayjs().subtract(1, "day");
              const start = yesterday.startOf("day");
              const end = yesterday.endOf("day").subtract(1, "millisecond");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "今天",
            onClick(picker) {
              const start = dayjs().startOf("day");
              const end = dayjs();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              let start = dayjs()
                .startOf("week")
                .add(1, "day");
              let end = dayjs();
              // 判断当前日期是否是周日，如果是则-1天处理
              if (dayjs().isSame(dayjs().startOf("week"))) {
                start = dayjs()
                  .subtract(1, "day")
                  .startOf("week")
                  .add(1, "day");
              }
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const start = dayjs().startOf("month");
              const end = dayjs().subtract(1, "millisecond");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本年",
            onClick(picker) {
              // 获取当前年份
              const currentYear = dayjs().year();
              const start = dayjs(`${currentYear}-01-01`);
              const end = dayjs().subtract(1, "millisecond");
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },

  watch: {
    currentDate: {
      handler(newVal, oldVal) {
        if (Array.isArray(newVal)) {
          this.date = [...newVal];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onDateChange(v) {
      this.$emit(
        "current-date-change",
        (v ?? []).map((date) => {
          return dayjs(date).format("YYYY-MM-DD");
        })
      );
    },
  },
};
</script>
<style>
.shortcut-datetime {
  display: inline-block;
}
.shortcut-datetime .el-date-editor.el-date-editor--datetimerange {
  width: auto;
  max-width: none;
}
</style>
